import styled from 'styled-components'

export const ViewContentAsset = styled.div`
    width: 100%;
    display: flex;
    /* align-items: center; */
    justify-content: center;
    flex-wrap: wrap;
    .top-bar {
        background: ${({ theme }) => theme['gray-200']};
        width: 100%;
        display: flex;
        justify-content: center;
    }
`

export const NoInfo = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    padding: 20px;
`

export const BackToTitle = styled.div`
    display: flex;
    font-size: 12px;
    padding: 12px 20px;

    @media (min-width: 992px) {
        &.back-to-title-container {
            width: 750px;
            width: 970px;
        }
    }
    @media (min-width: 1600px) {
        &.back-to-title-container {
            width: 1170px;
        }
    }

    button {
        background: transparent;
        padding: 0;
        margin: 0;
        font-size: 14px;
        color: ${({ theme }) => theme['blue-500']};
        border: none;
        font-weight: 600;

        span {
            margin-left: 8px;
            color: ${({ theme }) => theme['gray-700']};
        }
    }
`
